import apiOffice from "../axios/apiOffice";

class UserMuniService {
  // 1. Variable privada y estática para almacenar los datos
  static #cachedMunis = null;

  /**
   * 2. Método estático para obtener la lista de municipales.
   * Carga los datos solo una vez y los retorna desde la caché en llamadas subsiguientes.
   */
  static async getAll() {
    // A. Verificar si los datos ya están en caché
    if (UserMuniService.#cachedMunis) {
      return { success: true, data: UserMuniService.#cachedMunis };
    }

    // B. Si no están en caché, hacer la solicitud a la API
    try {
      const response = await apiOffice.get(`/municipales/munis`);

      if (response.status < 400) {
        // C. Guardar la data exitosa en la caché
        UserMuniService.#cachedMunis = response.data;
        return { success: true, data: response.data };
      }

      return {
        success: false,
        message: "Unexpected response status",
        status: response.status,
      };
    } catch (error) {
      console.error("Error getting person:", error);
      return {
        success: false,
        message: error.message,
        status: error.response?.status || 500,
      };
    }
  }

  /**
   * 3. (Opcional) Método para forzar la recarga de los datos
   */
  static async refreshMunis() {
    // Forzar la limpieza de la caché para que el próximo getAll() haga la llamada API
    UserMuniService.#cachedMunis = null;
    return UserMuniService.getAll();
  }
}

export default UserMuniService;
